module.exports = __webpack_public_path__ + "static/media/mask-passo2.1eb87688.jpg";